import React from "react";
import Logo from "../assets/logo.png";
import Mp3Player from "../Components/Mp3Player";
const Mp3Page = ({ qrData }) => {
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>
      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>

      <Mp3Player
        name={`${qrData?.first_name || ""} ${qrData?.last_name || ""}`}
        song={
          qrData?.mp3 ||
          "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
        }
      />
    </div>
  );
};

export default Mp3Page;
